// extracted by mini-css-extract-plugin
export default {"textblock":"ewR24e2tX8sbfocMbXAJ"};